import { Link } from "react-router-dom";
import { Minus, Plus, Trash2 } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "../ui/sheet";
import { useCart } from "../../context/CartContext";
import { money } from "../../lib/products";

export const QtyStepper = ({ value, onChange, testId }) => (
  <div className="inline-flex items-center rounded-full border-2 border-dano-ink">
    <button type="button" onClick={() => onChange(value - 1)} data-testid={`${testId}-decrease`} aria-label="Decrease" className="grid h-9 w-9 place-items-center hover:text-dano-red"><Minus className="h-4 w-4" /></button>
    <span data-testid={`${testId}-value`} className="w-8 text-center font-cond text-lg">{value}</span>
    <button type="button" onClick={() => onChange(value + 1)} data-testid={`${testId}-increase`} aria-label="Increase" className="grid h-9 w-9 place-items-center hover:text-dano-red"><Plus className="h-4 w-4" /></button>
  </div>
);

export const CartDrawer = () => {
  const { items, subtotal, open, setOpen, setQty } = useCart();
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent data-testid="cart-drawer" className="flex w-full flex-col border-l-2 border-dano-ink bg-dano-cream p-0 sm:max-w-md">
        <SheetHeader className="border-b-2 border-dano-ink px-6 py-5 text-left">
          <SheetTitle className="font-wide text-2xl uppercase text-dano-ink">Your cart</SheetTitle>
          <SheetDescription className="text-dano-ink/70">Test mode. No payment is taken.</SheetDescription>
        </SheetHeader>
        <div className="flex-1 overflow-y-auto px-6 py-4" data-lenis-prevent>
          {items.length === 0 ? (
            <div className="py-16 text-center" data-testid="cart-empty">
              <p className="font-wide text-xl uppercase">Empty for now</p>
              <Link to="/shop" onClick={() => setOpen(false)} data-testid="cart-empty-shop-link" className="mt-4 inline-block font-cond uppercase tracking-widest text-dano-red underline underline-offset-4">Go to shop</Link>
            </div>
          ) : (
            <ul className="divide-y divide-dano-ink/15">
              {items.map((i) => (
                <li key={i.key} className="flex gap-4 py-4" data-testid={`cart-item-${i.key.replace(":", "-")}`}>
                  <img src={i.image} alt={i.name} className="h-20 w-20 rounded-xl object-cover" />
                  <div className="flex flex-1 flex-col gap-2">
                    <div className="flex justify-between gap-2">
                      <div>
                        <p className="font-semibold leading-tight">{i.name}</p>
                        <p className="text-sm text-dano-ink/70">{i.variantLabel} · <span className="text-dano-red">Coming soon</span></p>
                      </div>
                      <p className="font-cond text-lg">{money(i.price * i.qty)}</p>
                    </div>
                    <div className="flex items-center justify-between">
                      <QtyStepper value={i.qty} onChange={(q) => setQty(i.key, q)} testId={`cart-qty-${i.variant}`} />
                      <button onClick={() => setQty(i.key, 0)} data-testid={`cart-remove-${i.variant}`} aria-label="Remove" className="text-dano-ink/60 hover:text-dano-red"><Trash2 className="h-4 w-4" /></button>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
        {items.length > 0 && (
          <div className="border-t-2 border-dano-ink px-6 py-5">
            <div className="flex justify-between font-cond text-xl uppercase tracking-wider">
              <span>Subtotal</span>
              <span data-testid="cart-subtotal">{money(subtotal)}</span>
            </div>
            <p className="mt-1 text-sm text-dano-ink/70">Shipping details will be set at launch.</p>
            <Link to="/checkout" onClick={() => setOpen(false)} data-testid="checkout-button" className="btn-press mt-4 flex w-full items-center justify-center rounded-full bg-dano-red py-4 font-cond text-lg uppercase tracking-widest text-dano-cream hover:bg-dano-red-dark">
              Checkout
            </Link>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
};
